import { forwardRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { AssetCategory } from '@/shared/lib/sj-orm/models/assets';
import { BaseProps } from '@/shared/types';

import { AssetCategory as AssetCategoryComponent } from './AssetCategory';

type SelectAssetCategoryV2Props = BaseProps<{
  onSelect: (category: AssetCategory) => void;
  filter?: AssetCategory[];
}>;

const groups = [
  [AssetCategory.DEBIT_ACCOUNTS, AssetCategory.METAL_ACCOUNTS, AssetCategory.BANK_CELLS],
  [AssetCategory.RESIDENTIAL_REAL_ESTATE, AssetCategory.COMMERCIAL_REAL_ESTATE, AssetCategory.LAND],
  [
    AssetCategory.BROKERAGE_ACCOUNT,
    AssetCategory.SECURITIES_AND_STOCKS,
    AssetCategory.BONDS,
    AssetCategory.FORWARDS,
    AssetCategory.FUTURES,
    AssetCategory.EXCHANGE_OPTIONS,
    AssetCategory.OVER_THE_COUNTER_OPTIONS,
    AssetCategory.PUBLIC_FUND,
  ],
  [AssetCategory.LEGAL_ENTITIES],
  [AssetCategory.MY_FUND],
  [AssetCategory.CENTRALIZED_WALLET],
  [AssetCategory.DECENTRALIZED_WALLET],
  [AssetCategory.COMMODITY_ASSET_TOKENS],
  [AssetCategory.JEWELLERY],
  [AssetCategory.PRECIOUS_STONES],
];

export const SelectAssetCategoryV2 = forwardRef<HTMLDivElement, SelectAssetCategoryV2Props>(
  ({ onSelect, filter, ...props }, ref) => {
    return (
      <Container {...props} className="uikitScrollbarNone" ref={ref}>
        {groups
          .filter((group) => group.some((item) => !filter || filter.includes(item)))
          .map((group, index) => (
            <Group key={index}>
              {group
                .filter((category) => !filter || filter.includes(category))
                .map((category) => (
                  <Item onClick={() => onSelect(category)} key={category}>
                    <AssetCategoryComponent category={category} />
                  </Item>
                ))}
            </Group>
          ))}
      </Container>
    );
  },
);

SelectAssetCategoryV2.displayName = 'SelectAssetCategoryV2';

const Container = styled.div`
  width: 280px;
  max-height: 435px;
  padding: 4px;
  border-radius: 16px;
  border: 1px solid ${COLORS.systemDark100};
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight300};
`;

const Group = styled.div`
  padding: 4px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight100};
`;

const Item = styled.div`
  height: 44px;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background: ${COLORS.systemLight200};
  }
`;
